export const TRACKING_ATTRIBUTES = {
  trackingTrigger: 'data-track',
  trackingObject: 'data-owc-tracking-object',
};

export const VALUES = {
  sessionStorageLoginState: 'ow_aem_loginstate',
  loggedOut: 'logged out',
  anchorTag: 'A',
  noPayloadOnFirstInitError: 'Please provide the Tracking Payload on the first intialization',
};

export const TRACKING_DATA_ATTRIBUTES = {
  componentAction: 'data-tracking-action',
};

export const MISSING_TRACKING_DATA = 'MISSING_DATA';
